// Slice
export { editorSyncSlice, decrementTempId, setStoryTitle } from './editorSyncSlice'

// Shared actions (cross-slice)
export {
  editorInitialized,
  editorCleared,
  editorMerged,
  slideSyncPending,
  slideSyncFulfilled,
  slideSyncRejected,
  slideReset,
  allChangesReset,
} from './actions'

// Thunks
export { initializeFromStory } from './thunks/initializeFromStory'
export { addLayer } from './thunks/addLayer'
export { removeLayer } from './thunks/removeLayer'
export { syncSlide } from './thunks/syncSlide'
export { syncAllSlides } from './thunks/syncAllSlides'
export { renameStory } from './thunks/renameStory'

// Utilities
export { computeLayerOperations } from './utils/computeOperations'

// Selectors
export {
  selectModifiedSlideIds,
  selectHasUnsavedChanges,
  selectSlideHasChanges,
  selectAllTextLayersMap,
  selectAllImageLayersMap,
  selectAllNonBgLayersMap,
  selectBackgroundLayerMap,
  selectFullLayersMap,
  selectSyncStatus,
  selectStoryId,
  selectStoryTitle,
} from './editorSyncSelectors'

// Types
export type { EditorSyncState } from './types'
